import type { PropsWithChildren } from 'react';

import { Text } from '@backyard-ui/core';

interface DescriptionProps extends PropsWithChildren {}

function Description(props: DescriptionProps) {
  const { children } = props;

  return <Text size="lg">{children}</Text>;
}

export default Description;
